export const verifyIfIsAfterStatusPause = (
  atdsimult,
  isFuturePauseActive,
  isReconnecting,
) => {
  if (isReconnecting && isFuturePauseActive) return true;
  if (!isReconnecting && isFuturePauseActive && atdsimult.length > 1)
    return true;
  return false;
};
